import _defineProperty from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
var GitHubButton = /*#__PURE__*/function (_PureComponent) {
  _inherits(GitHubButton, _PureComponent);
  var _super = _createSuper(GitHubButton);
  function GitHubButton(props) {
    var _this;
    _classCallCheck(this, GitHubButton);
    _this = _super.call(this, props);
    _this.$ = React.createRef();
    _this._ = React.createRef();
    return _this;
  }
  _createClass(GitHubButton, [{
    key: "render",
    value: function render() {
      return React.createElement('span', {
        ref: this.$
      }, React.createElement('a', _objectSpread(_objectSpread({}, this.props), {}, {
        ref: this._
      }), this.props.children));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.paint();
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate() {
      this.reset();
      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.paint();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.reset();
    }
  }, {
    key: "paint",
    value: function paint() {
      var _this2 = this;
      var _ = this.$.current.appendChild(document.createElement('span'));
      import( /* webpackMode: "eager" */'github-buttons').then(function (_ref) {
        var render = _ref.render;
        if (_this2._.current != null) {
          render(_.appendChild(_this2._.current), function (el) {
            try {
              _.parentNode.replaceChild(el, _);
            } catch (_) {}
          });
        }
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.$.current.replaceChild(this._.current, this.$.current.lastChild);
    }
  }]);
  return GitHubButton;
}(PureComponent);
export default GitHubButton;